import React from 'react'

import { Spacer } from '@zet/common/components/loader/spacer'
import { MotiView } from '@zet/common/components/motiView'
import { Stack, XStack } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

const CustomerListSkeleton = () => {
  return (
    <Stack className="flex-1 bg-white">
      <MotiView
        transition={{
          type: 'timing',
        }}
        animate={{ backgroundColor: '#ffffff' }}
        className="px-2"
      >
        <XStack className="items-center">
          <Stack className="mr-2">
            <Skeleton
              radius={'square'}
              height={48}
              colorMode={'light'}
              width={48}
            />
          </Stack>
          <Spacer />
          <Stack>
            <Skeleton height={15} colorMode={'light'} width={'60%'} />
            <Spacer />
            <Skeleton height={15} colorMode={'light'} width={'60%'} />
          </Stack>
          <Skeleton height={15} colorMode={'light'} width={'45%'} />
        </XStack>
      </MotiView>
    </Stack>
  )
}

export default CustomerListSkeleton
